import { Pipe, PipeTransform } from '@angular/core';
import { addClass, removeClass } from '../../../../../utils/toggle-class/toggle-class';
import compareAsc from 'date-fns/compareAsc';
import startOfDay from 'date-fns/startOfDay';

@Pipe({
  name: 'isRange',
  standalone: false
})
export class IsRangePipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    let date = value;
    let fromDate = args[0];
    let toDate = args[1];
    let hoveredDate = args[2];
    let availabilityObj: {} = args[3];
    let day: HTMLElement = args[4];

    if (day.classList.contains('calendar__month-week-date--modified')) {
      day.parentElement.removeAttribute('disabled');
      removeClass('date-disabled calendar__month-week-date--modified', day);
    }

    if (
      fromDate &&
      toDate &&
      availabilityObj &&
      Object.keys(availabilityObj).length !== 0 &&
      Object.getPrototypeOf(availabilityObj) === Object.prototype
    ) {
      let availabilityArray = [].concat.apply([], Object.values(availabilityObj));

      let availabilityArrayRange = availabilityArray.filter((date) => {
        if (
          compareAsc(
            startOfDay(new Date(date.date + 'T00:00')),
            startOfDay(new Date(fromDate.year, fromDate.month - 1, fromDate.day))
          ) >= 0 &&
          compareAsc(
            startOfDay(new Date(toDate.year, toDate.month - 1, toDate.day)),
            startOfDay(new Date(date.date + 'T00:00'))
          ) >= 0
        ) {
          return date;
        }
      });

      availabilityArrayRange.map((date, i) => {
        if (
          !date.isBookable &&
          i !== availabilityArrayRange.length - 1 &&
          day.classList.contains('calendar__month-week-date-' + date.date)
        ) {
          day.parentElement.setAttribute('disabled', 'date-disabled');
          addClass('date-disabled calendar__month-week-date--modified', day);
        }
      });
    }

    return (
      date.equals(fromDate) ||
      date.equals(toDate) ||
      (date.after(fromDate) && date.before(toDate)) ||
      (fromDate && !toDate && hoveredDate && date.after(fromDate) && date.before(hoveredDate))
    );
  }
}
